import { SvgIcon } from '@mui/material';
import { type SvgIconProps } from '@mui/material/SvgIcon';

export const NoFillSvgIcon = (props: SvgIconProps) => {
  return <SvgIcon sx={{ fill: 'none', fontSize: 'inherit' }} {...props} />;
};
